import React, { useState, useEffect, useRef } from "react";
import { Box, Button, Card, Divider, Grid, IconButton, ListItemIcon, Menu, MenuItem, MenuList, Popover, TextField, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import LinkIcon from '@mui/icons-material/Link';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ReportIcon from '@mui/icons-material/Report';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import ApiService from "../../utils/ApiService";
import { openSnackbar } from "../../features/snackbar/snackbarSlice";

const SingleMenu = ({ feedPostData, getCurrentMenu, reactPost, handleClick, setSnackBar, indivisualAPI, feedPostName, anchorEl, setAnchorEl, menus  }) => {
  const dispatch = useDispatch()
  const userData = useSelector((state) => state?.user?.userListName)
  const open = Boolean(anchorEl);

  const renderMoreIcons = (menus) => {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <IconButton
          aria-label="more"
          id="long-button"
          onClick={(e) => handleClick(e, menus)}
        >
          <MoreVertIcon />
        </IconButton>
      </Box>
    )
  }

  const getMenuItem = (menu) => {
    switch (menu.type) {
      case 'Save': return (
        <MenuItem key="Save" onClick={(e) => { menu.onClick(); }}>
          <ListItemIcon>
            <BookmarkBorderIcon fontSize="medium" />
          </ListItemIcon>
          <Typography variant="body1">Save</Typography>
        </MenuItem>)
      case 'Unsave': return (<MenuItem key="Unsave" onClick={(e) => { menu.onClick(); }}>
        <ListItemIcon>
          <BookmarkIcon fontSize="medium" />
        </ListItemIcon>
        <Typography variant="body1">Unsave</Typography>
      </MenuItem>)
      case 'Copy': return (<MenuItem key="Copy" onClick={() => handleCopyLink(window.location.origin + encodeUrl())}>
        <ListItemIcon>
          <LinkIcon fontSize="medium" />
        </ListItemIcon>
        <Typography variant="body1">Copy Link</Typography>
      </MenuItem>)
      case 'Edit': return (<MenuItem key="Edit" onClick={(e) => { menu.onClick(); }}>
        <ListItemIcon>
          <EditIcon fontSize="medium" />
        </ListItemIcon>
        <Typography variant="body1">Edit</Typography>
      </MenuItem>)
      case 'Delete': return (<MenuItem key="Delete" onClick={(e) => { menu.onClick(); }}>
        <ListItemIcon>
          <DeleteIcon fontSize="medium" />
        </ListItemIcon>
        <Typography variant="body1">Delete</Typography>
      </MenuItem>)
      case 'Report': return (<MenuItem key="Report" onClick={(e) => { menu.onClick(); }}>
        <ListItemIcon >
          <ReportIcon fontSize="medium" />
        </ListItemIcon>
        <Typography variant="body1">Report</Typography>
      </MenuItem>)
      case 'Hide': return (<MenuItem key="Hide" onClick={(e) => { menu.onClick(); }}>
        <ListItemIcon>
          <VisibilityOffIcon fontSize="medium" />
        </ListItemIcon>
        <Typography variant="body1">Hide</Typography>
      </MenuItem>)
    }
  }

  const handleCopyLink = (url) => {
    navigator.clipboard.writeText(url)
      .then(() => {
        dispatch(openSnackbar({ dataLoad: true, message: 'Your link has been copied successfully..', severity: "info" }));
      })
      .catch((error) => {
      });
  };

  const encodeUrl = () => {
    const queryStringObject = {
      indivisualAPI: indivisualAPI,
      reactPost: reactPost,
      feedPostName: feedPostName,
    };
    return `/feed/${feedPostData.id}`;
  }
  const getMenus = (menus) => {
    return menus.map(menu => {
      return getMenuItem(menu)
    });
  }
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Grid item xs={2} sm={2} md={2} lg={2}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }} key={"menu" + feedPostData.id}>
        {/* {renderMoreIcons(getCurrentMenu(feedPostData))} */}
      </Box>
      <Menu
        id={"long-menu" + feedPostData.id}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuList>
          {getMenus(menus)}
        </MenuList>
      </Menu>
    </Grid>
  );
}

export default SingleMenu;
